import React, { Component } from 'react';
import classes from './FullscreenImage.module.scss';

class FullscreenImage extends Component{
    
    selector = "FullscreenImage";
    
    cleanContainer = () => {
        const container = document.getElementById(this.selector);
        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }
    }
    
    loadImage = () => {
        let nimg = new Image();
        nimg.onload = () => {
            this.fullscreen();
        };
        
        nimg.src = this.props.src + '&width=1920&height=1920';
        console.log(nimg.src);
        
        document.getElementById(this.selector).appendChild(nimg);
    }

    fullscreen = () => {
        let img = document.getElementById(this.selector);
        if (img.requestFullscreen) {
            img.requestFullscreen();
        }
        else if (img.msRequestFullscreen) {
            img.msRequestFullscreen();               
        }
        else if (img.mozRequestFullScreen) {
            img.mozRequestFullScreen();      
        }
        else if (img.webkitRequestFullscreen) {
            img.webkitRequestFullscreen();       
        } else {
            console.log("Fullscreen API is not supported");
        }
        
        this.props.onFullscreen();
    }

    render(){
        return(
            <div 
                className={classes.FullscreenImage} 
                id={this.selector}
                allowFullScreen="allowfullscreen"></div>    
        )
    }
    
    componentDidUpdate() {
        if(this.props.fullscreen) {
            this.cleanContainer();
            this.loadImage();
        }
    }
}


export default FullscreenImage;


